async function apiRequest(path, options = {}) {
  const response = await fetch(`/api${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    ...options
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.error || 'Error de red');
    error.status = response.status;
    error.errors = data.errors;
    throw error;
  }
  return data;
}

export function getBooks(params = {}) {
  const query = new URLSearchParams(params).toString();
  return apiRequest(`/books${query ? `?${query}` : ''}`);
}

export function getBook(slug) {
  return apiRequest(`/books/${slug}`);
}

export function getAuthors() {
  return apiRequest('/authors');
}

export function getAuthor(slug) {
  return apiRequest(`/authors/${slug}`);
}

export function getReviews(params = {}) {
  const query = new URLSearchParams(params).toString();
  return apiRequest(`/reviews${query ? `?${query}` : ''}`);
}

export function getReview(slug) {
  return apiRequest(`/reviews/${slug}`);
}

export function getPosts(params = {}) {
  const query = new URLSearchParams(params).toString();
  return apiRequest(`/posts${query ? `?${query}` : ''}`);
}

export function getPost(slug) {
  return apiRequest(`/posts/${slug}`);
}

export function getPodcastEpisodes() {
  return apiRequest('/podcast-episodes');
}

export function sendContactMessage(payload) {
  return apiRequest('/contact', { method: 'POST', body: JSON.stringify(payload) });
}

export function subscribeNewsletter(payload) {
  return apiRequest('/newsletter/subscribe', { method: 'POST', body: JSON.stringify(payload) });
}
